import React, { useEffect, useState, useCallback } from 'react';
import Loading from '../../loading/Loading';
import TableLayout, { TD, inputSx } from '../../ui/TableLayout';
import { DeleteBtn, Actions } from '../../ui/ActionButtons';
import Apis from '../../Apis';
import { FaRegHandshake } from 'react-icons/fa';
import axios from 'axios';

const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const COLS = ['Cliente', 'Representante', 'Observação', 'Data', 'Ações'];
const headers = () => ({ 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') });

export default function ListarVisitas() {
  const t = today();
  const [dataIni, setDataIni] = useState(localStorage.getItem('@adm_pedido_data_ini_visita') || t);
  const [dataFim, setDataFim] = useState(localStorage.getItem('@adm_pedido_data_fim_visita') || t);
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [perPage, setPerPage] = useState(25);

  const fetchVisitas = useCallback((ini, fim) => {
    setLoading(true);
    axios.post(
      Apis.urlListarVisitas,
      { data_ini: ini, data_fin: fim, pesquisa: search, qtd_registros: perPage },
      { headers: headers() }
    )
      .then((res) => setData(res.data.registros || []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [search, perPage]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetchVisitas(dataIni, dataFim); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleIni = (v) => { setDataIni(v); localStorage.setItem('@adm_pedido_data_ini_visita', v); };
  const handleFim = (v) => { setDataFim(v); localStorage.setItem('@adm_pedido_data_fim_visita', v); };

  const Toolbar = (
    <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #d1d5db', borderRadius: 4, overflow: 'hidden', background: '#fff', height: 34 }}>
      <input type="date" value={dataIni}
        onChange={e => handleIni(e.target.value)}
        style={{ border: 'none', outline: 'none', padding: '0 8px', fontSize: 13, fontFamily: 'inherit', color: '#111827', background: 'transparent', height: '100%', width: 132 }} />
      <input type="date" value={dataFim}
        onChange={e => handleFim(e.target.value)}
        style={{ border: 'none', outline: 'none', padding: '0 8px', fontSize: 13, fontFamily: 'inherit', color: '#111827', background: 'transparent', height: '100%', width: 132, borderLeft: '1px solid #e5e7eb' }} />
      <button onClick={() => fetchVisitas(dataIni, dataFim)}
        style={{ border: 'none', borderLeft: '1px solid #e5e7eb', height: '100%', padding: '0 14px', background: '#f3f4f6', color: '#374151', fontSize: 12, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'background 0.15s' }}
        onMouseEnter={e => e.currentTarget.style.background = '#e5e7eb'}
        onMouseLeave={e => e.currentTarget.style.background = '#f3f4f6'}>
        Buscar
      </button>
    </div>
  );

  if (loading) return <Loading />;

  return (
    <TableLayout
      title="Lista de Visitas"
      icon={<FaRegHandshake style={{ fontSize: 18 }} />}
      count={data.length}
      columns={COLS}
      search={{ value: search, onChange: setSearch, placeholder: 'Buscar por cliente ou representante…', onSubmit: () => fetchVisitas(dataIni, dataFim) }}
      pagination={{ value: perPage, onChange: setPerPage }}
      toolbar={Toolbar}
      emptyMessage="Nenhuma visita encontrada para o período selecionado."
    >
      {data.map((c, i) => (
        <tr key={c.id}
          style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc' }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#eff6ff')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#fff' : '#f8fafc')}
        >
          <TD left uppercase>{c.cliente?.fantasia || c.cliente?.nome}</TD>
          <TD uppercase>{c.representante?.nome}</TD>
          <TD left>{c.obs}</TD>
          <TD>{c.data_hora}</TD>
          <TD>
            <Actions>
              <DeleteBtn url={Apis.urlDeletarVisita} id={c.id} redirect="listar-visitas" component="Visita" texto={`Deseja realmente excluir a visita ao cliente ${c.cliente?.nome}`} />
            </Actions>
          </TD>
        </tr>
      ))}
    </TableLayout>
  );
}
